export const SIDEBAR_ICON_ONLY_KEY = 'sidebarIconOnly';

export function applySidebarIconOnlyPreference() {
  const body = document.body;
  if (!body) {
    return;
  }
  const pref = sessionStorage.getItem(SIDEBAR_ICON_ONLY_KEY);
  if (pref === '0') {
    body.classList.remove('sidebar-icon-only');
  } else {
    body.classList.add('sidebar-icon-only');
  }
}

export function setSidebarIconOnlyPreference(enabled) {
  sessionStorage.setItem(SIDEBAR_ICON_ONLY_KEY, enabled ? '1' : '0');
  applySidebarIconOnlyPreference();
}

export function defaultSidebarIconOnlyAfterLogin() {
  sessionStorage.setItem(SIDEBAR_ICON_ONLY_KEY, '1');
  if (document.body) {
    document.body.classList.add('sidebar-icon-only');
  }
}

export function clearSidebarIconOnlyPreference() {
  sessionStorage.removeItem(SIDEBAR_ICON_ONLY_KEY);
}
